import React, {Component} from 'react';
import './Notifications.css';
import {connect} from 'react-redux';
import actions from './notifications.actions';
import {Link} from 'react-router-dom';
import FancyButton from '../widgets/FancyButton';

const getIconFromType = type =>
	({
		chat: 'icon-chat',
		profile: 'icon-person',
		community: 'icon-people',
		notice: 'icon-dashboard',
		communityInvite: 'icon-people'
	}[type] || 'icon-info');

const canBeAccepted = type =>
	({
		communityInvite: true
	}[type] || false);

class Notifications extends Component {
	constructor(props) {
		super(props);

		this.checkForRetrieval = props => {
			if (props.currentUser && !props.notifications.items && !props.notifications.retrieving) {
				props.retrieve();
			}
		};

		this.checkForRetrieval(props);

		this.dismissItem = item => e => {
			e.preventDefault();
			e.stopPropagation();
			this.props.dismiss(item.type, item.key);
		};

		this.acceptItem = item => e => {
			this.props.accept(item.type, item.key);
		};
	}

	componentWillReceiveProps(nextProps) {
		this.checkForRetrieval(nextProps);
	}

	render() {
		const {
			notifications: {items},
			accept
		} = this.props;

		if (!items || !items.length) {
			return (
				<ol className="Notifications">
					<li>
						<div>
							<span className="icon icon-notifications" />
							<div className="Notifications-content">
								<em>You have no notifications at this time!</em>
							</div>
						</div>
					</li>
				</ol>
			);
		}

		return (
			<ol className="Notifications">
				{items.map(item => {
					const children = [
						<span key="icon" className={`icon ${getIconFromType(item.type)}`} />,
						<div key="content" className="Notifications-content">
							<div className="Notifications-title">{item.title}</div>
							<div className="Notifications-preview">{item.content}</div>
							{canBeAccepted(item.type) ? (
								<div className="Notifications-actions">
									<FancyButton onClick={this.acceptItem(item)}>Accept</FancyButton>
								</div>
							) : (
								undefined
							)}
						</div>,
						<button key="remove" onClick={this.dismissItem(item)}>
							<span className="icon icon-remove_circle" />
						</button>
					];

					return (
						<li key={`${item.type}_${item.key}`}>
							<Link to={item.href} onClick={this.props.onItemClick}>
								{children}
							</Link>
						</li>
					);
				})}
			</ol>
		);
	}
}

const ConnectedNotifications = connect(
	({session, notifications}) => ({
		currentUser: session && session.current && session.current.user,
		notifications
	}),
	dispatch => ({
		accept: (type, key) => dispatch(actions.acceptNotification(type, key)),
		dismiss: (type, key) => dispatch(actions.dismissNotification(type, key)),
		retrieve: () => dispatch(actions.retrieveNotifications())
	})
)(Notifications);

export default ConnectedNotifications;



// WEBPACK FOOTER //
// ./src/user/Notifications.js